<template>
    <div class="p-5">
        <div class="d-flex justify-content-between align-items-center mb-5" v-if="supporterData">
            <div class="d-flex justify-content-start">
                <div class="c-title">
                    Supporter:
                    <span v-text="supporterData.first_name + ' ' + supporterData.last_name"></span>
                </div>
                <div class="c-title ml-5">
                    Total Donations:
                    <span v-text="formatNumber(supporterData.total_donations)"></span>
                </div>
            </div>
            <button
                @click="goBack"
                class="btn c-btn-add align-self-end"
            >
                Back
            </button>
        </div>

        <div class="">
            <div class="row mt-2 pl-2 pr-2">
                <div class="col-md-6 col-sm-12">

                    <TextField
                        v-model="firstName"
                        name="first_name"
                        label="First Name"
                        disabled
                    />
                    <TextField
                        v-model="lastName"
                        name="last_name"
                        label="Last Name"
                        disabled
                    />

                    <TextField
                        v-model="organizationName"
                        name="organization_name"
                        label="Business Name"
                        disabled
                    />

                    <TextField
                        v-model="email"
                        name="email"
                        label="Email"
                        disabled
                    />

                    <TextField
                        v-model="phone"
                        name="phone"
                        label="Phone"
                        disabled
                    />


                </div>
                <div class="col-md-6 col-sm-12">

                    <TextField
                        v-model="address"
                        name="address"
                        label="Address"
                        disabled
                    />

                    <TextField
                        v-model="address2"
                        name="address2"
                        label="Address line 2"
                        disabled
                    />

                    <TextField
                        v-model="city"
                        name="city"
                        label="City"
                        disabled
                    />

                    <div class="row">
                        <div class="col-md-8 col-sm-12">
                            <TextField
                                v-model="state"
                                name="state"
                                label="State"
                                disabled
                            />
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <TextField
                                v-model="zip"
                                name="zip"
                                label="Zip code"
                                disabled
                            />
                        </div>
                    </div>

                    <TextField
                        v-model="country"
                        name="country"
                        label="Country"
                        disabled
                    />
                </div>

            </div>
        </div>

        <div class="d-flex justify-content-start">
            <div class="c-title">
                Donations
            </div>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead class="c-thead">
                    <tr>
                        <th scope="col"
                            class="h-date"
                        >
                            Date
                        </th>
                        <th scope="col"
                            class="h-amount"
                        >
                            Amount
                        </th>
                        <th scope="col" class="h-email">Campaign</th>
                        <th scope="col" class="h-email">Designation</th>

                        <th scope="col" class="h-action"></th>
                    </tr>
                </thead>
                <tbody v-if="supporterData && supporterData.donations.length">
                    <TableItem
                        v-for="(item, index) in supporterData.donations"
                        :key="index"
                        :data="item"
                    />
                </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">No data</td>
                </tr>
              </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import TableItem from './SupporterViewTableItem.vue';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import TextField from "@/commons/FormElements/TextField.vue";
export default {
    name: 'SupporterView',
    components: {
        TextField,
        TableItem,
    },
    data() {
        return {
            inputEmail: '',
            supporterData: null,

            firstName: '',
            lastName: '',
            organizationName: '',
            email: '',
            phone: '',
            address: '',
            address2: '',
            city: '',
            zip: '',
            state: '',
            country: '',
        };
    },
    watch: {
        supporterData(val) {
            this.firstName = val.first_name;
            this.lastName = val.last_name;
            this.organizationName = val.business_name;
            this.email = val.email;
            this.phone = val.phone;
            this.address = val.address1;
            this.address2 = val.address2;
            this.city = val.city;
            this.zip = val.zip_code;
            this.state = val.state;
            this.country = val.country;
        }
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'SupportersList' });
        },
        getData() {
            DibbleJs.showLoader();
            const params = {
                '#request': DibbleApi.api.supporterGetByEmail,
                email: this.inputEmail,
            };

            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.supporterData = response;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        formatNumber(number) {
            return new Intl.NumberFormat('en-US').format(number);
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
        },
    },
    created() {
        this.inputEmail = this.$route.params.email;
        if (!this.inputEmail) {
            this.$router.push({ name: 'SupportersList' });
            DibbleJs.toastErrorMessage('Invalid email');
        } else {
            this.getData();
        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.c-archive-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-btn-add {
    color: #fff;
    width: 120px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-thead {
    th {
        color: #41B8DC;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-date {
            width: 10%;
        }
        &.h-phone {
            width: 10%;
        }
        &.h-email {
            width: 20%;
        }
        &.h-donation {
            width: 15%;
            text-align: right;
        }
        &.h-amount {
            width: 15%;
            text-align: right;
        }
        &.h-action {
            width: 25%;
        }
    }
}
.filter-date, .donation-filter {
    width: 340px;
    background-color: #e1e7e9;
    padding: 5px 16px 8px 16px;
    border-radius: 12px;
    position: relative;
    height: 59px;
    cursor: pointer;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    @media (max-width: 1750px) {
        width: auto;
    }

}
.donation-filter {
    width: 310px;
    height: 45px;

    /* Fix width on smaller screen*/
    @media (max-width: 1750px) {
        width: auto;
    }
}
</style>
<style lang="scss">
.filter-date {
    .form-control {
        background: none;

        div {
            input {
                background: none;
                border: none;
            }
        }

        .vdp-datepicker__clear-button {
            position: absolute;
            right: 1px;
            bottom: 10px;
        }
    }
}
.donation-filter {
    .multiselect__tags {
        background: transparent;
    }

    .multiselect__input, .multiselect__single {
        background: transparent;
        border: none;
        padding-top: 5px;
        color: #969fa2;
    }

    .multiselect__select {
        right: 3px;
        top: 9px;
        &:before {
            display: none
        }
    }
}

.checkbox-label {
    display: block;
}

.test {
    position: absolute;
    right: 1vw;
    width: 18px;
    height: 18px;
}
.clear-filter-button {
    font-size: 20px; color: #40b8dc;
}
</style>

